import { pathOr } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	sort: 'min_communication_start,desc',
	quickFilter: null,
	selectedGroup: null,
	communicationGroups: [],
};

const getFirstIdOrNull = pathOr(null, ['0', 'id']);

const reducerMap = {
	[types.CHANGE_QUICK_FILTER]: (state, { payload }) => {
		return {
			...state,
			quickFilter: payload.type,
		};
	},
	[types.SELECT_COMMUNICATION_GROUP]: (state, { payload }) => {
		return {
			...state,
			selectedGroup: payload.groupId,
		};
	},
	[types.SET_SORT]: (state, { payload }) => {
		return {
			...state,
			sort: payload.sort,
		};
	},
	[types.SET_COMMUNICATION_GROUPS]: (state, { payload }) => {
		return {
			...state,
			selectedGroup: getFirstIdOrNull(payload.groups),
			communicationGroups: payload.groups,
		};
	},
	[types.APPEND_COMMUNICATION_GROUPS]: (state, { payload }) => {
		return {
			...state,
			communicationGroups: state.communicationGroups.concat(payload.groups),
		};
	},
	[types.RESET]: () => initialState,
};

export default handleActions(reducerMap, initialState);
